<template>
  <modal name="member-mingle-update-modal" class="member-mingle-update-modal"
         :width="300"
         :height="'auto'"
         @before-open="handlerBeforeOpen"
         @before-close="handlerBeforeClose"
  >
    <div class="modal_title">밍글 관리</div>
    <button class="close_btn" style="z-index: 99" @click="closeModal"></button>
    <div class="text_center mt30 mb30">
      <el-radio-group class="radioBox" v-model="memberMingleUpdate">
        <el-radio :label="'ADMINPLUS'">지급</el-radio>
        <el-radio :label="'ADMINMINUS'">차감</el-radio>
      </el-radio-group>
    </div>
    <div>
      <el-input class="text_center modal_el_input" type="tel" v-model="mingle"
            @input="returnNumber('mingle', mingle)"></el-input>
    </div>
    <div class="pl30 pr30 pb30">
      <div class="btn_box text-center mt20">
        <el-button class="reg_btn_out" @click="save">학인</el-button>
      </div>
    </div>
  </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import priceMixins from "@/mixins/priceMixins";

export default {
  name: "MemberMingleUpdateModal",
  mixins: [priceMixins],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      memberMingleUpdate: 'ADMINPLUS',
      mingle: '',
      realMingle: 0,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    handlerBeforeOpen(event) {
      this.mingle = '';
    },
    handlerBeforeClose() {
      this.$router.replace(this.$route.path);
    },
    closeModal() {
      this.$modal.hide('member-mingle-update-modal')
    },
    parentChange(type, value) {
      console.log(this[type])
      console.log(value)
      this[type] = value
      this.memberWriteSetData(type, value);
    },
    save(){
      EventBus.$emit('updateMemberMingle', this.memberMingleUpdate, this.realMingle);
      this.$modal.hide('member-mingle-update-modal')
    },
    returnNumber(type, price) {
      let number = this.returnMaxPrice(price);
      this.realMingle = number;
      this[type] = util.Number.numFormat(number);
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>